/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const productOverviewNodes = document.querySelectorAll('.product-overview');
if (productOverviewNodes.length > 0) {
    import(/* webpackChunkName: "ProductOverview" */ './components/ProductOverview').then(({default: ProductOverview}) => {
        [...productOverviewNodes].forEach((node) => render(<ProductOverview {...parseDataToProps(node.dataset)} />, node));
    });
}
